<script>
	import * as d3 from "d3";
	import {onMount} from "svelte";

	let pointsArray = [];
	
    export let hash;
	export let w = 400
	export let h = 600
    export let stroke = false;
    export let bgtransparent = false;


	let r = 1
	let npoints = 20
	
    let rows = Math.ceil(h/npoints)
    let cols = Math.ceil(w/npoints)

    
    let fullw = npoints*cols
    let fullh = npoints* rows

    let xshift = fullw-w
    let yshift = fullh-h


	let svgElement
	let svg
	let delaunay
	let voronoi
	
	onMount(()=>{

		createPointsObject((Math.random()*300)+200);	
		
		svg = d3.select(svgElement).append('svg')
      .attr('width', w)
      .attr('height', h)
      .style('background-color', '#fff')

		delaunay = d3.Delaunay.from(pointsArray, d => d.x, d => d.y ),
    // Generate the voronoi diagram from our delaunay triangulation
    // Takes the bounds of our diagram area as arguments [x0,y0,x1,y1]
    voronoi = delaunay.voronoi([ 0, 0, w, h ])
  
    
    svg.append("rect")
        .attr("x",0)
        .attr("y", 0)
        .attr("width", w)
        .attr("height",h)
        .attr("fill", "white")



svg.selectAll('path')
   .data( pointsArray.map((d,i) => delaunay.renderTriangle(i)) )
      .join('path')
        .attr('d', d => d)
        .style("fill", (d,i) => "rgba(0,0,0,"+randomNumber()+")")        
        .attr('stroke', 'white')        
        .attr('stroke-width', stroke ? 0 : 0)        
        .attr('stroke-linejoin', 'round')
	

        // svg.append("rect")
        // .attr("x",0)
        // .attr("y", 0)
        // .attr("width", w)
        // .attr("height",h)        
        // .attr("stroke", "white")
        // .attr("stroke-width", stroke ? 32 : 0 );	



	})



    



    function randomNumber() {
		return (Math.random()+.2);
	}
    

	function randomPointNearRect(x, y, w, h, minDist, maxDist) {
  const dist = (Math.random() * (maxDist - minDist) + minDist) | 0;
  x += dist;
  y += dist;
  w -= dist  * 2
  h -= dist  * 2
  if (Math.random() <  w / (w + h)) { // top bottom
    x = Math.random() * w + x;
    y = Math.random() < 0.5 ? y : y + h -1;
  } else {
    y = Math.random() * h + y;
    x = Math.random() < 0.5 ? x: x + w -1;
  }
  return [x | 0, y | 0];
}
	
function createPointsObject(n){
    
    var i = 0
	while (i < n) {

		var point = {}
		point.x = randomPointNearRect(0,0,w,h, 0,0)[0]
		point.y = randomPointNearRect(0,0,w,h,0,0)[1]
		pointsArray.push(point);
		i++;
	}
	// console.log(pointsArray)
}	

	

  

  
  // Generate the delaunay triangulation of our data
  // takes data, x accessor and y accessor as arguments

  
//   svg.selectAll('path')
//       // Construct a data object from each cell of our voronoi diagram
//       .data( pointsArray.map((d,i) => voronoi.renderCell(i)) )
//       .join('path')
//         .attr('d', d => d)
//         .style('fill', "#ccc")
//         .style('opacity', 0.8)
//         .style('stroke', 'white')
//         .style('stroke-opacity', 0.2)
 
  
  // append all of our points so that we can see how they line up with the voronoi
//   svg.selectAll('circle')
//     .data( pointsArray )
//     .join('circle')
//     .attr('cx', d => d.x)
//     .attr('cy', d => d.y)
//     .attr('r', 1.5)
//     .style('fill', 'black')
	



	
</script>


<svg class="voronoibg-{hash}" viewbox="0 0 {w} {h}" bind:this={svgElement} />
